import { ApplyItemSearchOptions } from "models";
import React, { useEffect } from "react";

type PROPS = {
  options: ApplyItemSearchOptions;
  onChange: () => void;
  disabled?: boolean;
};

const ExhibitSearchSortSelect: React.FC<PROPS> = (props) => {
  const [sortOrder, setSortOrder] = React.useState<string>("");

  useEffect(() => {
    const tmp = props.options.sort_order ?? "";
    setSortOrder(tmp);
  }, [props.options.sort_order]);

  return (
    <select
      className="border border-gray-600 rounded py-2 cursor-pointer"
      value={sortOrder}
      onChange={(e) => {
        const value = e.target.value;
        props.options.sort_order = value;
        setSortOrder(value);

        props.onChange();
      }}
      disabled={props.disabled}
    >
      <option value="update_date_new">更新日が新しい順</option>
      <option value="update_date_old">更新日が古い順</option>
      <option value="price_high">価格が高い順</option>
      <option value="price_low">価格が低い順</option>
    </select>
  );
};

export default ExhibitSearchSortSelect;
